import { Injectable } from '@angular/core';

@Injectable()
export class MethodsUtils {
  // getFormatTime(time: string | number | Date): string {
  //   return moment(time).format('HH:mm') ?? String(time);
  // }

  getStatuses(
    enumData: Record<string, string | number>,
    filter: string | null = null,
    exclude: string[] | null = null,
    cap = true
  ): { title: string; value: string | number; active: boolean }[] {
    let myEnum: { title: string; value: string | number; active: boolean }[] = [];
    const objectEnum = Object.keys(enumData);

    const values = objectEnum.slice(0, objectEnum.length / 2);
    const keys = objectEnum.slice(objectEnum.length / 2);

    for (let i = 0; i < objectEnum.length / 2; i++) {
      myEnum.push({
        title: cap ? this.capitalise(keys[i]) : keys[i],
        value: values[i],
        active: false,
      });
    }

    if (filter) {
      myEnum = myEnum.filter((item) =>
        item.title.toLowerCase().includes(filter.slice(0, 5))
      );
    }

    if (exclude) {
      myEnum = myEnum.filter((item) => !exclude.includes(item.title.toLowerCase()));
    }

    return myEnum;
  }

  capitalise(value: string): string {
    const removeUnderscore = value.split('_').join(' ');
    return removeUnderscore.charAt(0).toUpperCase() + removeUnderscore.slice(1).toLowerCase();
  }

  getValues(enumData: Record<string, number | string>, status: number) {
    const enumArray = this.getStatuses(enumData, null, ['none'], false);
    const bits = Object.keys(enumData)
      .map(Number)
      .filter((n) => !isNaN(n));
    const booleans = bits.map((b) => (status & b) === b);
    const indices = booleans.flatMap((b, i) => (b ? i : []));
    indices.forEach((i) => (enumArray[i].active = true));
    return enumArray;
  }

  getTitles(enumData: Record<string, string | number>): string[] {
    const enumArray = this.getStatuses(enumData);
    return enumArray.map((item) => item.title);
  }
}
